<template>
  <div
    class="VisionLoadingSpinner"
    :class="[
      { 'VisionLoadingSpinner--loading': loading },
      `VisionLoadingSpinner--spinner-colour-${spinnerColour}`,
      `VisionLoadingSpinner--overlay-colour-${overlayColour}`,
      `VisionLoadingSpinner--size-${size}`,
    ]"
  >
    <div class="VisionLoadingSpinner__spinner-container">
      <div class="VisionLoadingSpinner__spinner" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VisionLoadingSpinner',

  props: {
    loading: { type: Boolean, default: false },

    spinnerColour: {
      type: String,
      default: 'blue',
      validator(value) {
        return ['blue', 'white'].includes(value)
      },
    },

    overlayColour: {
      type: String,
      default: 'transparent',
      validator(value) {
        return ['grey', 'transparent'].includes(value)
      },
    },

    size: {
      type: String,
      default: 'medium',
      validator(value) {
        return ['small', 'medium'].includes(value)
      },
    },
  },
}
</script>

<style lang="postcss">
.VisionLoadingSpinner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 11000;
  color: #666;
  text-align: center;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.5s ease, visibility 0.5s ease;
}

.VisionLoadingSpinner__spinner-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.VisionLoadingSpinner__spinner {
  @apply border-2;
  animation: rotate 0.5s infinite linear;
  border-radius: 50%;
}

/* STATES */

.VisionLoadingSpinner--loading {
  opacity: 0.8;
  visibility: visible;
  pointer-events: auto;
}

/* SPINNER COLOURS */

.VisionLoadingSpinner--spinner-colour-white {
  .VisionLoadingSpinner__spinner {
    @apply border-white;
    border-right-color: transparent;
  }
}

.VisionLoadingSpinner--spinner-colour-blue {
  .VisionLoadingSpinner__spinner {
    @apply border-blue;
    border-right-color: transparent;
  }
}

/* OVERLAY COLOURS */

.VisionLoadingSpinner--overlay-colour-grey {
  background-color: rgba(255, 255, 255, 0.8);
}

.VisionLoadingSpinner--overlay-colour-transparent {
  background-color: transparent;
}

/* SIZES */

.VisionLoadingSpinner--size-small {
  .VisionLoadingSpinner__spinner {
    @apply w-4 h-4;
  }
}

.VisionLoadingSpinner--size-medium {
  .VisionLoadingSpinner__spinner {
    @apply w-8 h-8;
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
